import { useSelector } from 'react-redux'

export const Currency = ({ children, locale, currencyCode, withCode = false }) => {
  const code = ` ${currencyCode.toUpperCase()}`

  return (
    parseFloat(children).toLocaleString(locale, {
      style: 'currency',
      currency: currencyCode
    }) + (withCode ? code : '')
  )
}

const LocalCurrency = ({ children, withCode = false }) => {
  const { locale, currency } = useSelector(s => s.hotelDetails)

  const code = ` ${currency.toUpperCase()}`

  return (
    parseFloat(children).toLocaleString(locale, {
      style: 'currency',
      currency
    }) + (withCode ? code : '')
  )
}

export const USCurrency = ({ children, withCode = false }) =>
  parseFloat(children).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  }) + (withCode ? ' USD' : '')

export default LocalCurrency
